// extracted by mini-css-extract-plugin
module.exports = {"questions":"questions___2Zi1O","drawerHeader":"drawerHeader___3RL2l"};